import React from 'react'
import renderHTML from 'react-render-html'
import Audio from 'react-audioplayer'
import './react-audioplayer.scss'
import './styles.scss'

class EpisodeAudio extends React.Component<Props, State> {
  ref = null

  constructor(props) {
    super(props)
    this.state = {
      isMobile: window.innerWidth <= 768,
      isSmallMobile: window.innerWidth <= 320
    }
    this.toggleAudio = this.toggleAudio.bind(this)
  }

  toggleAudio() {
    // console.log('toggleAudio')
    // console.log(this.ref)
    this.ref.state.playing
      ? this.ref.audioElement.pause()
      : this.ref.audioElement.play()
  }

  componentDidMount() {
    if (this.state.isMobile) {
      this.ref.audioElement.onplay = () => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'Interactions',
          event_action: 'click',
          event_label: 'play: ' + this.props.name
        })
      }
    }
  }

  render() {
    const songObj = {
      name: this.props.name, // song name
      src: this.props.audioFile // song source address
    }
    const filesToPLay = [songObj]
    let playerWidth = window.innerWidth - 36
    if (window.innerWidth === 768) {
      playerWidth = 715
    }

    return (
      <div>
        {this.state.isMobile || this.props.isArchived ? (
          <div className='episode'>
            <div
              className='toggler'
              onClick={this.toggleAudio}
              style={{
                height: '65%',
                zIndex: '999999999',
                position: 'absolute',
                width: '100%'
              }}
            />
            <div className='content'>
              <h3>
                <span>Folge {this.props.episodeNr}</span>
              </h3>
            </div>
            <div className='poster'>
              <img src={this.props.photo} />
            </div>
            <div className='title'>
              <h2>{this.props.name}</h2>
              <div className='subline'>
                <div className='cards-icon'>
                  <img src={require('./cards-mobile.svg')} />
                </div>
                <div className='tags'>{renderHTML(this.props.tags)}</div>
              </div>
            </div>
            {this.state.isMobile && (
              <Audio
                playlist={filesToPLay}
                color='#e23c4e'
                style={{
                  width: playerWidth,
                  zIndex: '999',
                  position: 'relative'
                }}
                ref={element => {
                  this.ref = element
                }}
              />
            )}

            {!this.state.isMobile && (
              <iframe
                height='52px'
                width='100%'
                frameBorder='no'
                scrolling='no'
                seamless
                src={
                  'https://player.simplecast.com/' +
                  this.props.simpleCastID +
                  '?dark=true'
                }
              />
            )}
          </div>
        ) : (
          <div className='episode'>
            <div className='content'>
              <h3>
                <span>Folge {this.props.episodeNr}</span>
              </h3>
              <div className='title'>
                <h2>{this.props.name}</h2>
                <div className='subline'>
                  <div className='cards-icon'>
                    <img src={require('./cards.svg')} />
                  </div>
                  <div className='tags'>{renderHTML(this.props.tags)}</div>
                </div>
              </div>
              <iframe
                height='52px'
                width='100%'
                frameBorder='no'
                scrolling='no'
                seamless
                src={
                  'https://player.simplecast.com/' +
                  this.props.simpleCastID +
                  '?dark=true'
                }
              />
            </div>
            <div className='poster'>
              <img src={this.props.photo} />
            </div>
          </div>
        )}
        <div className='about'>
          <div className='quote'>{renderHTML(this.props.quote)}</div>
          {this.props.about}
          {this.props.spotifyURL && (
            <div className='links'>
              <a href={this.props.spotifyURL}>
                <i className='icon spotify' />
                {this.state.isSmallMobile ? 'Spotify' : 'über Spotify hören'}
              </a>
              <a href={this.props.appleURL} style={{ float: 'right' }}>
                <i className='icon apple' />
                {this.state.isSmallMobile
                  ? 'Apple Podcasts'
                  : 'über Apple Podcasts hören'}
              </a>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default EpisodeAudio
